import type { History } from 'history';
import React from 'react';
import type { RouteComponentProps as RouterProps } from 'react-router';
import { withRouter } from 'react-router';

export const RootHistoryContext = React.createContext<History | null>(null);

type RootHistoryContextProviderProps = RouterProps & { children: React.ReactNode };

const RootHistoryContextProvider: React.FC<RootHistoryContextProviderProps> = ({
  history,
  children
}) => <RootHistoryContext.Provider value={history}>{children}</RootHistoryContext.Provider>;

const WithRouterRootHistoryContextProvider = withRouter(
  (props: RootHistoryContextProviderProps) => <RootHistoryContextProvider {...props} />
);

export default WithRouterRootHistoryContextProvider;
